var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"fill-height py-0"},[_c('v-col',{staticClass:"py-0 pl-0 pr-4 pr-lg-0 d-none d-lg-flex tree-menu-width",attrs:{"cols":"12","lg":"2"}},[_vm._t("left")],2),_c('v-row',[_c('v-col',{staticClass:"pb-2 pt-0",attrs:{"height":"100vh"}},[_vm._t("right")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }